import angular from 'angular';
import { LocalProjects } from './local-projects.service/localProjects';
import { ProjectsDetail } from './projects-detail.view/projectsDetail';
import { ProjectDetailFilters } from './projects-detail.view/projectsDetailFilters';
import { ProjectsFilters } from './projects-filters.service/projectsFilters';
import { ProjectsIndex } from './projects-index.view/projectsIndex';
import { ProjectsIndexSidebar } from './projects-index.view/projectsIndexSidebar';
import { newProject } from './projects-new-project.view/projectsNewProject';
import { ProjectsRepository } from './projects-repository.service/projectsRepository';
import { ProjectStatus } from './projects-status.directive/project-status';

export default angular
    .module('tn.projects', [
        'tn.django',
        'tn.account',
        'tn.fonts',
        'tn.popover',
        'tn.user',
        'tn.licenses',
    ])
    // components
    .controller('tnProjectDetailFilters', ProjectDetailFilters)
    .controller('tnProjectsDetail', ProjectsDetail)
    .controller('tnProjectsIndexSidebar', ProjectsIndexSidebar)
    .controller('tnProjectsIndex', ProjectsIndex)
    .controller('tnProjectsNewProject', newProject)
    .directive('tnProjectStatus', ProjectStatus)
    // providers
    .service('localProjects', LocalProjects)
    .service('projectsRepository', ProjectsRepository)
    .service('tn.projects.filters.service', ProjectsFilters).name;
